import type {
	LoanForBusinessDetailDataDTO,
	PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { BUSINESS_LOANS_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/BusinessLoansForm/businessLoansFormDefaults";
import type { BusinessLoansFormInput } from "web_myplann/Portfolio/Forms/BusinessLoansForm/businessLoansFormSchema";
import { mapCoDebtorsToForm } from "web_myplann/Portfolio/Forms/CoDebtors/mapCoDebtorsToForm";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { toLoanPaymentFrequency } from "web_myplann/Portfolio/Helpers/loanPaymentFrequencies";

export const mapPortfolioToBusinessLoansForm = (
	portfolio: PortfolioDetailResponseDTO,
): BusinessLoansFormInput => {
	const data = portfolio.data as LoanForBusinessDetailDataDTO | undefined;

	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
		value: null,
		coDebtors: mapCoDebtorsToForm(data?.coDebtors),
		change: {
			originalObligationAmount:
				data?.originalObligationAmount ??
				DEFAULTS.change.originalObligationAmount,
			installment: data?.installment ?? DEFAULTS.change.installment,
			interestRate: data?.interestRate ?? DEFAULTS.change.interestRate,
			fixationEndDate: parseIsoDate(data?.fixationEndDate),
			paymentFrequency: toLoanPaymentFrequency(data?.paymentFrequency),
		},
	};
};
